import React from 'react';
import { type Argument, cs } from '@bbkAdminUtils/css-utils';
import { Badge } from '../badges/badge';
import { BadgeIcon } from '../badges/badge-icon';
import { BadgeText } from '../badges/badge-text';

import './styles/stat.scss';

type Props = {
  value: number | string;
  change?: number; // chevron direction >= 1 up, < 1 down
  bg?: number; // bg color of badge: >= 1 green, < 1 red
  outline?: boolean;
  outlineLight?: boolean;
  badgeClasses?: Argument;
  badgeIconClasses?: Argument;
};
export const StatBadge: React.FC<Props> = (props) => {
  const {
    change,
    value,
    badgeClasses,
    badgeIconClasses,
    bg,
    outline,
    outlineLight,
  } = props;
  const bgClass = bg
    ? bg >= 1
      ? 'bbk-badge-increase'
      : 'bbk-badge-decrease'
    : '';
  const arrowDir = change
    ? change >= 1
      ? 'bbk-badge-up'
      : 'bbk-badge-down'
    : 'bbk-badge-d-none';
  return (
    <Badge
      badgeClasses={cs(badgeClasses, 'bbk-badge-stat', bgClass, {
        'bbk-badge-outline': outline,
        'bbk-badge-outline-light bbk-badge-outline': outlineLight,
      })}
    >
      <BadgeIcon
        icon="chevronDown"
        badgeIconClasses={cs(badgeIconClasses, arrowDir, 'bbk-badge-rmarg')}
      />
      <BadgeText text={value} />
    </Badge>
  );
};
